import request from 'Request'

const InfoService = {
  async listAppCodes() {
    return request.post('/info/list/app-codes')
  },

  async listOffices() {
    return request.post('/info/list/offices')
  }
}

export default InfoService
